import { ApiResponse } from '@letly/models';

export const PROPERTY_LET_AGREED_ERROR_CODE = 'PROPERTY_LET_AGREED';

export function offerErrorMessage(res: ApiResponse<unknown>): string | undefined {
  return res.error?.error?.code === PROPERTY_LET_AGREED_ERROR_CODE
    ? $localize`:@@offering.error.let-agreed:This home is now let agreed, so it can no longer take offers.`
    : res.niceErrorMessage;
}
